export const FETCH_NEW_HOST_ONBOARDING_DATA = 'FETCH_NEW_HOST_ONBOARDING_DATA';
export const FETCH_NEW_HOST_ONBOARDING_DATA_SUCCESS = 'FETCH_NEW_HOST_ONBOARDING_DATA_SUCCESS';
export const FETCH_NEW_HOST_ONBOARDING_DATA_FAILS = 'FETCH_NEW_HOST_ONBOARDING_DATA_FAILS';

export const FETCH_NEW_HOST_ONBOARDING_DATA_BY_ID = 'FETCH_NEW_HOST_ONBOARDING_DATA_BY_ID';
export const FETCH_NEW_HOST_ONBOARDING_DATA_BY_ID_SUCCESS = 'FETCH_NEW_HOST_ONBOARDING_DATA_BY_ID_SUCCESS';
export const FETCH_NEW_HOST_ONBOARDING_DATA_BY_ID_FAILS = 'FETCH_NEW_HOST_ONBOARDING_DATA_BY_ID_FAILS';

export const COUNTRY_CODE_SUBMIT = 'COUNTRY_CODE_SUBMIT';
export const COUNTRY_CODE_SUBMIT_SUCCESS = 'COUNTRY_CODE_SUBMIT_SUCCESS';
export const COUNTRY_CODE_SUBMIT_ERROR = 'COUNTRY_CODE_SUBMIT_ERROR';